import { SVGProps } from 'react'

export const EmptyCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="15" height="15" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z 
           M12,21.6c-5.287,0-9.6-4.313-9.6-9.6S6.713,2.4,12,2.4s9.6,4.313,9.6,9.6S17.287,21.6,12,21.6z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)
